import React from 'react';
import { Typography } from 'antd';
import { BannerArrows } from '../../assets/images';

interface Props {
    text: any;
    onclick?: any;
}


const MainHeading = (props: Props) => {
    return (
        <Typography.Title className="main-heading" level={3} onClick={props?.onclick}>{props.text}</Typography.Title>
    )
}

export default MainHeading;

